const DataTable = ({
    columns,
    data,
    onEdit,
    onDelete,
    loading,
    error,
    // nuevas props para selección
    selectable = false,
    selectedIds = [],
    onSelectRow,
    onSelectAll,
}) => {
    if (loading) return <div className="sp-card"><p>Cargando...</p></div>;
    if (error) return <div className="sp-card sp-card--danger"><p>{error}</p></div>;
    if (!data.length) return <div className="sp-card"><p>No hay registros.</p></div>;

    const allSelected = data.length > 0 && data.every(row => selectedIds.includes(row.id));

    return (
        <div className="sp-card" style={{ padding: 0, overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr style={{ borderBottom: '1px solid var(--sp-border)', background: 'var(--sp-primary-soft)' }}>
                        {selectable && (
                            <th style={{ padding: '0.75rem 0.5rem', textAlign: 'center', width: 40 }}>
                                <input
                                    type="checkbox"
                                    checked={allSelected}
                                    onChange={onSelectAll}
                                    style={{ cursor: 'pointer' }}
                                />
                            </th>
                        )}
                        {columns.map(col => (
                            <th key={col.id || col.key} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: 800, fontSize: '0.85rem', color: 'var(--sp-text)' }}>
                                {col.label}
                            </th>
                        ))}
                        <th style={{ padding: '0.75rem 1rem', width: 120 }}>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, idx) => (
                        <tr key={row.id ?? idx} style={{ borderBottom: '1px solid var(--sp-border)' }}>
                            {selectable && (
                                <td style={{ padding: '0.75rem 0.5rem', textAlign: 'center' }}>
                                    <input
                                        type="checkbox"
                                        checked={selectedIds.includes(row.id)}
                                        onChange={() => onSelectRow(row.id)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </td>
                            )}
                            {columns.map(col => (
                                <td key={col.id || col.key} style={{ padding: '0.75rem 1rem', fontSize: '0.9rem' }}>
                                    {col.render
                                        ? col.render(row[col.key], row)
                                        : (row[col.key]?.toString() ?? '—')}
                                </td>
                            ))}
                            <td style={{ padding: '0.5rem 1rem', display: 'flex', gap: '0.4rem' }}>
                                {typeof onEdit === 'function' && (
                                    <button
                                        className="sp-btn"
                                        style={{ minHeight: 36, padding: '0.3rem 0.8rem', fontSize: '0.82rem' }}
                                        onClick={() => onEdit(row)}
                                    >
                                        Editar
                                    </button>
                                )}
                                {typeof onDelete === 'function' && (
                                    <button
                                        className="sp-btn sp-btn--danger"
                                        style={{ minHeight: 36, padding: '0.3rem 0.8rem', fontSize: '0.82rem' }}
                                        onClick={() => onDelete(row.id)}
                                    >
                                        Eliminar
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DataTable;